import React from 'react';
import Button from '#lib/components/button.jsx';
import { Icon } from '@iconify-icon/react';
import { Link } from 'react-router-dom';
import { useConnections } from '#src/@connections/use-connections.js';
import { cn } from '#lib/helpers/class.js';

export default function ConnectionsCard() {
    const [hoveredIndex, setHoveredIndex] = React.useState(null);
    const { data } = useConnections();

    return (
        <div className="md:h-[300px] rounded-lg md:w-1/2 p-3 flex flex-col gap-2 justify-between md:shadow-lg md:rounded-xl border-b border-b-neutral-200 md:border-none">
            <h2 className="font-bold text-lg mb-1">{_t.home.connectionsTitle()}</h2>
            {/* <p className="text-neutral-500">{_t.home.connectionsText()}</p> */}
            <ul className="w-full flex flex-col flex-grow gap-2">
                {data?.slice(0, 4).map((item, index) => {
                    const isHovered = hoveredIndex === index;
                    if (!item.connected) return null;
                    return (
                        <Link
                            to={item.connected ? `/manage/orders/${item.connectionId}` : '/manage/connections'}
                            key={index}
                        >
                            <div
                                className={cn(
                                    'flex justify-between items-center rounded-lg py-1 px-2',
                                    isHovered && 'bg-primary-50 text-primary-600'
                                )}
                                onMouseOver={() => setHoveredIndex(index)}
                                onMouseOut={() => setHoveredIndex(null)}
                            >
                                <span className={cn('italic text-neutral-900', isHovered && 'text-primary-600')}>
                                    {item.name}
                                </span>
                                <Icon
                                    icon="line-md:arrow-small-right"
                                    width="1.4rem"
                                    height="1.4rem"
                                    className={cn(isHovered && 'text-primary-600')}
                                />
                            </div>
                        </Link>
                    );
                })}
            </ul>
            <Link className="w-fit my-2 md:my-0" to="/manage/connections">
                <Button look="primary">
                    <React.Fragment>
                        <span>{_t.home.goToConnections()}</span>
                    </React.Fragment>
                    <Icon icon="line-md:arrow-small-right" width="1.4rem" height="1.4rem" className="ml-2 pt-1" />
                </Button>
            </Link>
        </div>
    );
}
